import { connect } from "../Axios";
import { CREATE_ORDER } from "./ApiUrl";

export const CreateRazerPayOrder = async (Amount, InvoiceNo) => {
  try {
    const response = await connect.post(CREATE_ORDER, null, {
      params: { Amount, InvoiceNo },
    });
    return response.data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
};
